import React from 'react';
import { Route } from 'react-router';
import { translate } from 'react-i18next';
import VehicleDetailsReservationContent from './VehicleDetailsReservationContent';
import VehicleDetailsReservationList from './VehicleDetailsReservationList';
import VehicleDetailsSectionHeader from './VehicleDetailsSectionHeader';
import CBMediaQuery from '../../shared/CBMediaQuery';

class VehicleDetailsMainReservation extends React.Component {
  render() {
    const { t, vehicle } = this.props;
    const reservations = vehicle.maintenance_reservations || [];
    return (
      <CBMediaQuery>
        {screenSize => (
          <div>
            <VehicleDetailsSectionHeader
              type='reservation'
              text={t('reservationsHeading')}
            />
            {screenSize === 'small' && <VehicleDetailsReservationList vehicle={vehicle} reservations={reservations} />}
            <div style={styles.mainContentContainer}>
              {screenSize !== 'small' && <VehicleDetailsReservationList vehicle={vehicle} reservations={reservations} />}
              <Route
                exact
                path='/vehicle/:vehicleId/reservations/'
                render={() => <VehicleDetailsReservationContent reservations={reservations} vehicle={vehicle} />}
              />
              <Route
                path='/vehicle/:vehicleId/reservations/:reservationId'
                render={props => <VehicleDetailsReservationContent reservations={reservations} {...props} vehicle={vehicle} />}
              />
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  mainContentContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
};

export default translate('VehicleDetailsView')(VehicleDetailsMainReservation);
